import { entityRoleEnum, FootballEntity, PlayerPositionsShortEnum, UserSubRole } from "../enums/entity.enum";
import { Country, EntityLevel, OverviewCard, PlayerPositions, PlayerPositionsShorts, UserInfo } from "../types";
import { formatImgUrl } from "./cardFormating";

export const getUserData = (data: UserInfo | undefined) => {
  let fullName: string = "",
    firstTwoChr: string = "",
    about: string = "",
    countryName: string = "",
    countryMedia: string = "",
    media: string = "",
    mediaFileName: string = "",
    role: string = "",
    verificationStatus: string = "",
    isVerified: boolean = false,
    profileViewers: number = 0,
    posts: number = 0,
    followersCount: number = 0,
    followingCount: number = 0,
    id: number | null = null,
    entityId: number | null = null,
    isFollowing: boolean = false,
    profileLink: string = "",
    mutualFollowersCount: number = 0,
    countryFlag: string = "",
    playerPositionShort: PlayerPositionsShorts | null = null,
    friendsCount: number | null = null,
    isManagedByEntity: boolean = false,
    entityLevel: EntityLevel | null = null,
    overview: OverviewCard[] = [],
    primaryPosition: PlayerPositions | string = "",
    otherPosition: PlayerPositions | string = "",
    countriesWorkedIn: Country[] = [];

  if (!data) {
    return {
      fullName: "",
      firstTwoChr: "",
      about: "",
      countryName: "",
      countryMedia: "",
      media: undefined,
      mediaFileName: "",
      role: "",
      profileViewers: 0,
      verificationStatus: "",
      isVerified: false,
      posts: 0,
      followersCount: 0,
      followingCount: 0,
      id: null,
      entityId: null,
      isFollowing: false,
      profileLink: "",
      mutualFollowersCount: 0,
      countryFlag: "",
      playerPositionShort: "",
      friendsCount: null,
      isManagedByEntity: false,
      entityLevel: null,
      overview: [],
      primaryPosition: "",
      otherPosition: "",
      countriesWorkedIn: [],
    };
  }

  if (data.entity) {
    fullName = data.entity.name;
    firstTwoChr = data.entity.name.slice(0, 2).toLocaleUpperCase();
    about = data.entity.about;
    countryName = data.entity.country.name;
    countryMedia = formatImgUrl(data.entity.country.url, true);
    media = formatImgUrl(data.entity.mediaUrl);
    mediaFileName = data.entity.mediaUrl;
    role = FootballEntity[data.entity.type];
    verificationStatus = data.verificationStatus;
    isVerified = data.verificationStatus === "VERIFIED";
    profileViewers = data.entity.profileViewers || 0;
    posts = data.entity.posts || 0;
    followersCount = data.entity.followersCount;
    followingCount = data.entity.followingCount || 0;
    id = data.id;
    entityId = data.entity.id;
    isFollowing = data.isFollowing || false;
    profileLink = `/dashboard/entity/${data.entity!.id}` || "";
    mutualFollowersCount = data.mutualFollowersCount || 0;
    countryFlag = formatImgUrl(data.entity.country.url);
    isManagedByEntity = data.entity.isManagedByEntity;
    entityLevel = data.entity.level;
  } else if (data.isEntity) {
    fullName = data.name || "";
    firstTwoChr = data.name?.slice(0, 2).toLocaleUpperCase() || "";
    about = data.about || "";
    countryName = data.country.name;
    countryMedia = formatImgUrl(data.country.url, true);
    media = formatImgUrl(data.mediaUrl);
    mediaFileName = data.mediaUrl || "";
    role = data.type ? FootballEntity[data.type as keyof typeof FootballEntity] : "";
    followersCount = data.followersCount;
    followingCount = data.followingCount || 0;
    id = data.userId || null;
    entityId = data.id || null;
    isFollowing = data.isFollowing || false;
    profileLink = `/dashboard/entity/${data.id}` || "";
    mutualFollowersCount = data.mutualFollowersCount || 0;
    countryFlag = formatImgUrl(data.country.url);
    isManagedByEntity = data.isManagedByEntity || false;
    entityLevel = (data.type as EntityLevel) || null;
  } else {
    fullName = `${data.firstName} ${data.lastName}`;
    firstTwoChr = `${data.firstName?.slice(0, 1)}${data.lastName?.slice(0, 1)}`.toLocaleUpperCase();
    about = data.bio;
    countryName = data.country.name;
    countryMedia = formatImgUrl(data.country.url, true);
    media = formatImgUrl(data.media?.url);
    mediaFileName = data.media?.url || "";
    role =
      data.role === "OTHER"
        ? UserSubRole[data.subRole as keyof typeof UserSubRole] || entityRoleEnum[data.role]
        : entityRoleEnum[data.role];
    verificationStatus = data.verificationStatus;
    isVerified = data.verificationStatus === "VERIFIED";
    profileViewers = data.profileViewers || 0;
    posts = data.posts || 0;
    followersCount = data.followersCount;
    followingCount = data.followingCount || 0;
    id = data.id;
    entityId = null;
    isFollowing = data.isFollowing || false;
    profileLink = `/dashboard/${data?.role?.toLowerCase()}/${data.id}`;
    mutualFollowersCount = data.mutualFollowersCount || 0;
    countryFlag = formatImgUrl(data.country.url);
    playerPositionShort = data.additionalProperties?.primaryPosition
      ? PlayerPositionsShortEnum[data.additionalProperties.primaryPosition] || ""
      : null;
    friendsCount = data.friendsCount || 0;
    overview = data.overview || [];
    primaryPosition = data.primaryPosition || "";
    otherPosition = data.otherPosition || "";
    countriesWorkedIn = data.countriesWorkedIn || [];
  }
  return {
    fullName,
    firstTwoChr,
    about,
    countryName,
    countryMedia,
    media,
    mediaFileName,
    role,
    profileViewers,
    verificationStatus,
    isVerified,
    posts,
    followersCount,
    followingCount,
    id,
    entityId,
    isFollowing,
    profileLink,
    mutualFollowersCount,
    countryFlag,
    playerPositionShort,
    friendsCount,
    isManagedByEntity,
    entityLevel,
    overview,
    primaryPosition,
    otherPosition,
    countriesWorkedIn,
  };
};
